import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'scDecimalComma',
  standalone: true,
})
export class DecimalCommaPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace('.', ',');
  }
}
